export var decodeAccessToken = function decodeAccessToken(token) {
    if (!token)
        return '';
    try {
        // JWT format: header.payload.signature
        var payload = token.split('.')[1];
        if (!payload)
            return '';
        var decoded = JSON.parse(atob(payload.replaceAll('-', '+').replaceAll('_', '/')));
        // Try common userId fields
        return decoded.username || decoded.sub || decoded.id || '';
    }
    catch (_unused) {
        return '';
    }
};
